import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { of, Subscription } from 'rxjs';
import { BackEndService } from 'src/app/backend-service';
import { widgetAdderColor } from 'src/app/globals';
import { IWidgetProviderService, WIDGET_PROVIDER_SERVICE } from 'src/app/interfaces';
import { EMailAudit } from 'src/app/lib/mail/classes';
import { AbstractWidgetInner, WidgetInnerData, WidgetInnerView } from 'src/app/widget-inner';

@Component({
  selector: 'app-assignment-mail-widget-inner',
  templateUrl: './assignment-mail-widget-inner.component.html',
  styleUrls: ['./assignment-mail-widget-inner.component.css']
})
export class AssignmentMailWidgetInnerComponent extends AbstractWidgetInner {

  @Input() set data(data: WidgetInnerData) {
    this._data = data;
    this.loadContent();
  }
  get data(): WidgetInnerData {
    return this._data;
  }

  viewSubscriptions: Subscription[] = [];

  mails: EMailAudit[] = [];
  mailsLoading: boolean = false;
  mailsLoaded: boolean = false;
  noMailsInBox: boolean = false;

  constructor(
    @Inject(WIDGET_PROVIDER_SERVICE) private _widgetProviderService: IWidgetProviderService,
    private _backEndService: BackEndService,
    private _router: Router
  ) {
    super();
  }

  loadContent() {
    this.mailsLoading = true;
    this._backEndService.get("api/mail/assignment").subscribe((assignmentMails: EMailAudit[]) => {
      if (assignmentMails.length > 0) {
        if (this.mails.length == 0) this.mails = assignmentMails;
        else {
          for (let mail of assignmentMails) {
            let loaded = this.mails.find(x => x.messageId === mail.messageId);
            if (!loaded) {
              this.mails.push(mail);
            }
          }
        }
        this.noMailsInBox = false;
      } else {
        this.mails = [];
        this.noMailsInBox = true;
      }
      this.mailsLoaded = true;
      this.mailsLoading = false;
    });
  }

  mailClicked(mail: EMailAudit){
    if(mail){
      this._router.navigate(["mail-inbox/assignment"], {
        queryParams: { 'mail-id': mail.messageId }
      });
    }
  }

  ngOnInit(): void {
    this._widgetProviderService.setWidgetInnerViews([
      {
        name: () => of('Eingang einsehen'),
        icon: () => of('all_inbox'),
        onClick: () => {
          this._router.navigate(['/mail-inbox', 'assignment']);
          return of(null);
        }
      } as WidgetInnerView,
      {
        name: () => of('Neuladen'),
        icon: () => of('refresh'),
        onClick: () => {
          this.refresh();
          return of(null);
        },
        color: () => of(widgetAdderColor)
      } as WidgetInnerView
    ]);
  }

  openAssignmentMailView() {
    this._router.navigate(["/mail-inbox/assignment"]);
  }

  refresh = () => this.loadContent();

}
